import React, { Component } from 'react'
import { api } from 'app/modules/sfdc/api'
import  SalesforcePlaybookCampaignSelect from '../SalesforcePlaybookCampaignSelect'
import  PlaybookInboxSelect  from '../PlaybookInboxSelect'

class PlaybookSelects extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isSalesforceConnected: false
        }
    }
    componentDidMount() {
        this.fetchSFDCConnection()
    }

    fetchSFDCConnection = async () => {
        try {
            const data = await api.fetchSFDCConnection()
            this.setState({
                isSalesforceConnected: data
            })
        }
        catch (e) {
            console.log(e)
        }
    }
    
    renderForPlaybookByType = (type) => {
        return type === "ABM" || 
        type === "EMPTY_WELCOME_MESSAGE" ||
        type === "TALK_TO_YOUR_OUTBOUND_PROSPECTS"
    }

    render() {
        const { playbookId, reportType } = this.props
        const { isSalesforceConnected } = this.state
    
        return (
            isSalesforceConnected && this.renderForPlaybookByType(reportType) ?
                <div className="inbox-select-wrapper">
                    <PlaybookInboxSelect />
                    <SalesforcePlaybookCampaignSelect
                        playbookId={playbookId}
                        description={`Associate leads/contacts from this playbook with a Salesforce Campaign`}
                        defaultSelectLabelText={"Search for a Salesforce Campaign"} />
                </div>
                :
                <div>
                    <PlaybookInboxSelect />
                </div>
        )
    }
}
export default PlaybookSelects


// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/PlaybookSelects/index.js